import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-filled-fields-report',
  templateUrl: './filled-fields-report.component.html',
  styleUrls: ['./filled-fields-report.component.scss']
})
export class FilledFieldsReportComponent implements OnInit {

  submiting: boolean = false;
  pieChartData: any;
  barChartData: any;
  barChartWidth: number = 0;
  pieChartWidth: number = 0;
  @ViewChild('barChartContainer', { static: false }) barChartContainer: any;
  @ViewChild('pieChartContainer', { static: false }) pieChartContainer: any;

  constructor(
    private http: HttpService,
    private errorReport: ErrorReportService,
    private snapshat: MatSnackBar
  ) {
    const subject = new Subject<any>();
    subject.subscribe(({ trigger, scope }: any) => {
      if (scope == 'analytics:filled_fields') {
        this.submiting = trigger == 'pre';
      }
    })
    this.http.setLoadingIndicator(subject, 'analytics:filled_fields')
  }

  ngOnInit(): void {
  }

  getFilledFields() {

    this.http.list('analytics:filled_fields')
      .subscribe(
        (result: any) => {

          const fields = result.grouped
          if (Object.keys(fields).length > 0) {

            this.barChartData = [
              {
                name: 'Email preenchidos',
                value: fields.qtd_email_preenchido
              },
              {
                name: 'CPF preenchidos',
                value: fields.qtd_cpf_preenchido
              },
              {
                name: 'Telefone preenchidos',
                value: fields.qtd_telefone_preenchido
              },
              {
                name: 'WhatsApp preenchidos',
                value: fields.qtd_whatsapp_preenchido
              },
              {
                name: 'Primeiro Nome preenchidos',
                value: fields.qtd_primeiro_nome_preenchido
              },
              {
                name: 'Sobrenome preenchidos',
                value: fields.qtd_sobrenome_preenchido
              },
              {
                name: 'Cargo Desejado preenchidos',
                value: fields.qtd_cargo_desejado_preenchido
              },
              {
                name: 'Sobre o Candidato preenchidos',
                value: fields.qtd_sobre_candidato_preenchido
              },
              {
                name: 'Sexo preenchidos',
                value: fields.qtd_sexo_preenchido
              },
              {
                name: 'Data de Nascimento preenchidos',
                value: fields.qtd_data_de_nascimento_preenchido
              },
              {
                name: 'CEP preenchidos',
                value: fields.qtd_cep_preenchido
              },
              {
                name: 'Estado preenchidos',
                value: fields.qtd_estado_preenchido
              },
              {
                name: 'Bairro preenchidos',
                value: fields.qtd_bairro_preenchido
              },
              {
                name: 'Logradouro preenchidos',
                value: fields.qtd_logradouro_preenchido
              },
              {
                name: 'Número preenchidos',
                value: fields.qtd_numero_preenchido
              },
              {
                name: 'Cidade preenchidos',
                value: fields.qtd_cidade_preenchido
              }
            ].sort((itemA, itemB) => itemA.value - itemB.value);

            this.pieChartData = [
              {
                name: 'Usuários com todos\ncampos preenchidos',
                value: result.totalFullfield
              },
              {
                name: 'Todos usuários',
                value: result.total - result.totalFullfield
              }
            ]

            setTimeout(() => {
              this.barChartWidth = this.barChartContainer.nativeElement.clientWidth / 2;
            }, 1000)
          } else {
            this.barChartData = []
          }
        }
      )

  }

}
